import React from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'antd';
import NoResults from 'components/NoResults';

const I18N_BASE_PATH =
  'pages.private.KYBCompany.pages.companyDetails.subPages.people.creditReport';

const ShareHoldersContent = ({ shareHoldersLength, shareholdersList }) => {
  const { t: translate } = useTranslation();

  if (!shareHoldersLength) {
    return <NoResults />;
  }

  return (
    <>
      <div className="current-tab-infos">
        <h4>
          {translate(
            `${I18N_BASE_PATH}.tabs.shareholders.currentShareholders.title`,
            'Current Shareholders'
          )}
        </h4>
      </div>
      <div className="credit-safe-shareholders">
        <Row className="credit-safe-shareholders-header">
          <Col span={4}>
            {translate(
              `${I18N_BASE_PATH}.tabs.shareholders.currentShareholders.columns.name`,
              'Name'
            )}
          </Col>
          <Col span={4}>
            {translate(
              `${I18N_BASE_PATH}.tabs.shareholders.currentShareholders.columns.currency`,
              'Currency'
            )}
          </Col>
          <Col span={4}>
            {translate(
              `${I18N_BASE_PATH}.tabs.shareholders.currentShareholders.columns.shareCount`,
              'Share Count'
            )}
          </Col>
          <Col span={4}>
            {translate(
              `${I18N_BASE_PATH}.tabs.shareholders.currentShareholders.columns.shareType`,
              'Share Type'
            )}
          </Col>
          <Col span={4}>
            {translate(
              `${I18N_BASE_PATH}.tabs.shareholders.currentShareholders.columns.nominalValue`,
              'Nominal Value'
            )}
          </Col>
          <Col span={4}>
            {translate(
              `${I18N_BASE_PATH}.tabs.shareholders.currentShareholders.columns.percentageOfShareCount`,
              '% of Share Count'
            )}
          </Col>
        </Row>
        {shareholdersList?.map((element) => (
          <Row className="shareholder-line" key={element?.name}>
            <Col span={4} className="name">
              {element?.name ?? '-'}
            </Col>
            <Col span={4}>{element?.currency ?? '-'}</Col>
            <Col span={4}>{element?.totalNumberOfSharesOwned ?? '-'}</Col>
            <Col span={4}>{element?.shareType ?? '-'}</Col>
            <Col span={4}>{element?.shareClassesValuePerShare?.[0] ?? '-'}</Col>
            <Col span={4}>{element?.percentSharesHeld ?? '-'}</Col>
          </Row>
        ))}
      </div>
    </>
  );
};

export default ShareHoldersContent;
